import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconSearchFlow({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4.5" y="8.5" width="5" height="7" rx=".5" stroke={fill}/>
            <rect x="14.5" y="4.5" width="5" height="6" rx=".5" stroke={fill}/>
            <rect x="14.5" y="13.5" width="5" height="6" rx=".5" stroke={fill}/>
            <path d="M10 12h2V9a1 1 0 0 1 1-1h1M10 12h2v3a1 1 0 0 0 1 1h1" stroke={fill}/>
        </svg>

    );
}

export default IconSearchFlow;
